"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Size = void 0;

var SizeAnimation_1 = require("./SizeAnimation");

var SizeRandom_1 = require("./SizeRandom");

var Size = /*#__PURE__*/function () {
  function Size() {
    _classCallCheck(this, Size);

    this.animation = new SizeAnimation_1.SizeAnimation();
    this.random = new SizeRandom_1.SizeRandom();
    this.value = 3;
  }

  _createClass(Size, [{
    key: "load",
    value: function load(data) {
      var _a;

      if (data === undefined) {
        return;
      }

      var animation = (_a = data.animation) !== null && _a !== void 0 ? _a : data.anim;

      if (animation !== undefined) {
        this.animation.load(animation);
      }

      if (data.random !== undefined) {
        if (typeof data.random === "boolean") {
          this.random.enable = data.random;
        } else {
          this.random.load(data.random);
        }
      }

      if (data.value !== undefined) {
        this.value = data.value;
      }
    }
  }, {
    key: "anim",
    get: function get() {
      return this.animation;
    },
    set: function set(value) {
      this.animation = value;
    }
  }]);

  return Size;
}();

exports.Size = Size;